import {Typography} from 'components/Typography';
import Link from 'next/link';
import style from './style.module.scss';
import {REVIEW_MODERATION_RULES_ROUTE} from 'core/modules/routing/constants';

interface IReviewModerationCaptionProps {
    entityLabel: string;
}

export const ReviewModerationCaption = ({entityLabel}: IReviewModerationCaptionProps) => {
    return (
        <Typography variant={'label'}>
            <span className={style.capitalize}>{entityLabel} появится на сайте после проверки.</span>
            <br />
            <span>Оставляя {entityLabel}, вы соглашаетесь с </span>
            <Link className={style.link} href={REVIEW_MODERATION_RULES_ROUTE} target={'_blank'}>
                правилами модерации
            </Link>
            .
        </Typography>
    );
};
